export default {
  SeatAssignment__AT_CHECK_IN: "at check-in",
  SeatAssignment__LAP_CHILD: "Lap child",
  SeatAssignment__NO_SEAT_SELECTED: "No seat selected",
  SeatAssignment__OPEN_SEATING: "Open seating",
  SeatAssignment__OTHER_AIRLINE: "Seat info unavailable for other airlines",
  SeatAssignment__SEAT_ASSIGNED: "Seat assigned",
  SeatAssignment__SEAT_ASSIGNMENT: (assignedSeat) => `Seat: ${assignedSeat}`,
  SeatAssignment__SEAT_SELECTION: "Seat selection",
  SeatAssignment__SKIPPED: "skipped",
};
